import { Button, Flex, Text } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

type HeaderProps = {
  updateStats: () => void;
  updatedAt?: number;
};

export const Header = ({ updatedAt, updateStats }: HeaderProps) => (
  <Flex align="center" justify="center" gap={10} p={10} style={{ flex: '0 0 70px' }}>
    <Button leftSection={<IconRefresh size={14} />} onClick={updateStats} size="sm" variant="light">
      Refresh
    </Button>
    <Text size="sm">
      Last refresh: {updatedAt ? new Date(updatedAt).toLocaleTimeString() : '—'}
    </Text>
  </Flex>
);
